export default {

    data(state) {
      return state.data
    },
    sequencedData: (state) => {
      const data = state.data.slice()
      switch (state.sortMethod) {
        case 'alphabet':
          return data
        case 'oldest':
          return data.sort(
            (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
          )
        case 'latest':
          return data.sort(
            (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
          )
        default:
          return data
      }
    },
    sortedData(state, getters) {
      const data = getters.sequencedData
      if (state.searchMethod === 'keyword' && state.keyword === '') return data
      if (state.searchMethod === 'empty') {
        return data.filter(
          (obj) =>
            !obj[state.type] ||
            obj[state.type].length === 0 ||
            String(obj[state.type]).trim().length === 0
        )
      }

      const keywordReplaced = state.keyword.replace(
        /[.*+\-?^${}()|[\]\\]/g,
        '\\$&'
      )
      // return data.filter(obj => obj[state.type].toString().match(new RegExp(keywordReplaced, 'gi')))
      return data.filter((obj) => {
        if (!obj[state.type]) return false
        if (
          state.env === 'DEV' &&
          state.type === 'ticket' &&
          obj['version'] <= state.qaVersion
        )
          return false
        const d = obj[state.type]
        return d.toString().match(new RegExp(keywordReplaced, 'gi'))
      })
    },
    type(state) {
      return state.type
    },
    env(state) {
      return state.env
    },
    pagination(state) {
      return state.pagination
    },
    keyword(state) {
      return state.keyword
    },
    searchMethod(state) {
      return state.searchMethod
    },
    isLoading(state) {
      return state.isLoading
    },
    projects(state) {
      return state.projects
    },
    project(state) {
      return state.project
    },
    cardsHistory(state) {
      return state.cardsHistory
    },
    messages(state) {
      return state.messages
    },
    idModal(state) {
      return state.idModal
    },
    isModal(state) {
      return state.isModal
    },
    user(state) {
      return state.user
    },
    langs(state) {
      return state.langs
    },
    langsMapping(state) {
      return state.langsMapping
    },
    isCountryList(state) {
      return state.project === 'country-list'
    },
    isHistoryMode(state) {
      return state.isHistoryMode
    },
    isDeployMode(state) {
      return state.isDeployMode
    },
    isApproveMode(state) {
      return state.isApproveMode
    },
    historyData(state) {
      return state.historyData
    },
    historyPageData(state) {
      return state.historyPageData
    },
    updatedTickets(state) {
      return state.updatedTickets
    },
    updatedTicketsPage(state) {
      return state.updatedTicketsPage
    },
    ticketVersion(state) {
      return state.ticketVersion
    },
    isConfirmApproveModalOpen(state) {
      return state.isConfirmApproveModalOpen
    },
    // approvedCards(state) {
    //     return state.approvedCards
    // },
    deployableVersions(state) {
      return state.deployableVersions
    },
    deployableVersionsPage(state) {
      return state.deployableVersionsPage
    },
    isConfirmDeployModalOpen(state) {
      return state.isConfirmDeployModalOpen
    },
    currentVersion(state) {
      return state.currentVersion
    },
    devVersion(state) {
      return state.devVersion
    },
    qaVersion(state) {
      return state.qaVersion
    },
    needValidateKey(state) {
      return state.needValidateKey
    },
    panelSetting(state) {
      return state.panelSetting
    },
  }
